import {ElementStyles} from "./ElementStyles";

export default function TextInputWeex({onChange, value = null, readOnly = false, placeholder, rows = 1, label = null, light = false, style = null, ...props}){

  //style it: https://react-select.com/styles
  const styles = {
    containerDiv: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: light? ElementStyles.color3: ElementStyles.color2,
      color: ElementStyles.color2,
      padding: ElementStyles.paddingLabels,
      minHeight: ElementStyles.height,
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "var(--white)",
      position: "relative",
    },
    input: {
      width: "calc(100% - 5px)",
      background: light? ElementStyles.color3: ElementStyles.color2,
      color: ElementStyles.color,
      border: "none",
      resize: "none",
      fontSize: 16,
      outline: "none"
    }
  };
  //https://react.dev/reference/react-dom/components/textarea
  return (
    <div style={{...styles.containerDiv, ...style}} {...props} className={"centerVertical"}>
      {label && value && <label style={{color: "var(--white)", position: "absolute", top: -11, zIndex: 1, left: 10, background: light? ElementStyles.color3: ElementStyles.color2, paddingLeft: 3, paddingRight: 3}}>{label}</label>}
      <textarea
        style={styles.input}
        placeholder={placeholder}
        rows={rows}
        onChange={(e)=> {
          if(rows === 1){
            e.target.value = e.target.value.replace("\n", "")
            onChange(e);
          }else
            onChange(e);
        }}
        value={value}
        readOnly={readOnly}
      />
      {/*<MarkdownPreview markdown={value} />*/}
    </div>
  );
};

